
import { Union, Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { ProblemReportId_$reflection, SetId_$reflection, LabelId_$reflection, ToolId_$reflection, ConsumableId_$reflection } from "./Shared.js";
import { int32_type, list_type, class_type, option_type, bool_type, union_type, record_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ReservationDto_$reflection } from "./Planning.js";

export class MinimumQuantityReminderConsumable extends Record {
    constructor(Id, CurrentStock, StorageName, DisplayName, MinimumQuantityStock, Unit) {
        super();
        this.Id = Id;
        this.CurrentStock = CurrentStock;
        this.StorageName = StorageName;
        this.DisplayName = DisplayName;
        this.MinimumQuantityStock = MinimumQuantityStock;
        this.Unit = Unit;
    }
}

export function MinimumQuantityReminderConsumable_$reflection() {
    return record_type("Shared.Dashboard.MinimumQuantityReminderConsumable", [], MinimumQuantityReminderConsumable, () => [["Id", ConsumableId_$reflection()], ["CurrentStock", string_type], ["StorageName", string_type], ["DisplayName", string_type], ["MinimumQuantityStock", string_type], ["Unit", string_type]]);
}

export class MinimumQuantityReminderToolWithQuantity extends Record {
    constructor(Id, CurrentStock, StorageName, DisplayName, MinimumQuantityStock) {
        super();
        this.Id = Id;
        this.CurrentStock = CurrentStock;
        this.StorageName = StorageName;
        this.DisplayName = DisplayName;
        this.MinimumQuantityStock = MinimumQuantityStock;
    }
}

export function MinimumQuantityReminderToolWithQuantity_$reflection() {
    return record_type("Shared.Dashboard.MinimumQuantityReminderToolWithQuantity", [], MinimumQuantityReminderToolWithQuantity, () => [["Id", ToolId_$reflection()], ["CurrentStock", string_type], ["StorageName", string_type], ["DisplayName", string_type], ["MinimumQuantityStock", string_type]]);
}

export class MinimumQuantityReminderTool extends Record {
    constructor(CategoryId, CurrentStock, StorageName, DisplayName, MinimumQuantityStock) {
        super();
        this.CategoryId = CategoryId;
        this.CurrentStock = CurrentStock;
        this.StorageName = StorageName;
        this.DisplayName = DisplayName;
        this.MinimumQuantityStock = MinimumQuantityStock;
    }
}

export function MinimumQuantityReminderTool_$reflection() {
    return record_type("Shared.Dashboard.MinimumQuantityReminderTool", [], MinimumQuantityReminderTool, () => [["CategoryId", LabelId_$reflection()], ["CurrentStock", string_type], ["StorageName", string_type], ["DisplayName", string_type], ["MinimumQuantityStock", string_type]]);
}

export class MinimumQuantityReminder extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["MinimumQuantityConsumable", "MinimumQuantityToolWithQuantity", "MinimumQuantityTool"];
    }
}

export function MinimumQuantityReminder_$reflection() {
    return union_type("Shared.Dashboard.MinimumQuantityReminder", [], MinimumQuantityReminder, () => [[["Item", MinimumQuantityReminderConsumable_$reflection()]], [["Item", MinimumQuantityReminderToolWithQuantity_$reflection()]], [["Item", MinimumQuantityReminderTool_$reflection()]]]);
}

export class ReceiverAssignment extends Record {
    constructor(ReceiverId, ReceiverName) {
        super();
        this.ReceiverId = ReceiverId;
        this.ReceiverName = ReceiverName;
    }
}

export function ReceiverAssignment_$reflection() {
    return record_type("Shared.Dashboard.ReceiverAssignment", [], ReceiverAssignment, () => [["ReceiverId", string_type], ["ReceiverName", string_type]]);
}

export class CurrentAssignment extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Storage", "Receiver"];
    }
}

export function CurrentAssignment_$reflection() {
    return union_type("Shared.Dashboard.CurrentAssignment", [], CurrentAssignment, () => [[["Item", string_type]], [["Item", ReceiverAssignment_$reflection()]]]);
}

export class ReminderDateInfoType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ToolReminder", "ToolWithQuantityReminder", "SetReminder", "ConsumableReminder"];
    }
}

export function ReminderDateInfoType_$reflection() {
    return union_type("Shared.Dashboard.ReminderDateInfoType", [], ReminderDateInfoType, () => [[["Item", ToolId_$reflection()]], [["Item", ToolId_$reflection()]], [["Item", SetId_$reflection()]], [["Item", ConsumableId_$reflection()]]]);
}

export class ReminderDateInfo extends Record {
    constructor(IsOverdue, ReminderDateInfoType, ToolTitle, ToolSubtitle, CurrentAssignment, Description, Date$) {
        super();
        this.IsOverdue = IsOverdue;
        this.ReminderDateInfoType = ReminderDateInfoType;
        this.ToolTitle = ToolTitle;
        this.ToolSubtitle = ToolSubtitle;
        this.CurrentAssignment = CurrentAssignment;
        this.Description = Description;
        this.Date = Date$;
    }
}

export function ReminderDateInfo_$reflection() {
    return record_type("Shared.Dashboard.ReminderDateInfo", [], ReminderDateInfo, () => [["IsOverdue", bool_type], ["ReminderDateInfoType", ReminderDateInfoType_$reflection()], ["ToolTitle", string_type], ["ToolSubtitle", string_type], ["CurrentAssignment", option_type(CurrentAssignment_$reflection())], ["Description", string_type], ["Date", class_type("System.DateTime")]]);
}

export class ElementId extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Tool", "Set"];
    }
}

export function ElementId_$reflection() {
    return union_type("Shared.Dashboard.ElementId", [], ElementId, () => [[["Item", ToolId_$reflection()]], [["Item", SetId_$reflection()]]]);
}

export class ToolReturnDateInfo extends Record {
    constructor(IsOverdue, ReturnDate, ReceiverName, ReceiverId, Title, Subtitle, Id) {
        super();
        this.IsOverdue = IsOverdue;
        this.ReturnDate = ReturnDate;
        this.ReceiverName = ReceiverName;
        this.ReceiverId = ReceiverId;
        this.Title = Title;
        this.Subtitle = Subtitle;
        this.Id = Id;
    }
}

export function ToolReturnDateInfo_$reflection() {
    return record_type("Shared.Dashboard.ToolReturnDateInfo", [], ToolReturnDateInfo, () => [["IsOverdue", bool_type], ["ReturnDate", class_type("System.DateTime")], ["ReceiverName", string_type], ["ReceiverId", string_type], ["Title", string_type], ["Subtitle", string_type], ["Id", ElementId_$reflection()]]);
}

export class ProblemReportInfo extends Record {
    constructor(Date$, ProblemReportId, SenderName, SenderId, Description, ToolTitle, ToolSubtitle, ToolId) {
        super();
        this.Date = Date$;
        this.ProblemReportId = ProblemReportId;
        this.SenderName = SenderName;
        this.SenderId = SenderId;
        this.Description = Description;
        this.ToolTitle = ToolTitle;
        this.ToolSubtitle = ToolSubtitle;
        this.ToolId = ToolId;
    }
}

export function ProblemReportInfo_$reflection() {
    return record_type("Shared.Dashboard.ProblemReportInfo", [], ProblemReportInfo, () => [["Date", class_type("System.DateTime")], ["ProblemReportId", ProblemReportId_$reflection()], ["SenderName", string_type], ["SenderId", string_type], ["Description", string_type], ["ToolTitle", string_type], ["ToolSubtitle", string_type], ["ToolId", ToolId_$reflection()]]);
}

export class InInMaintenanceInfoType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Tool", "Set"];
    }
}

export function InInMaintenanceInfoType_$reflection() {
    return union_type("Shared.Dashboard.InInMaintenanceInfoType", [], InInMaintenanceInfoType, () => [[["Item", ToolId_$reflection()]], [["Item", SetId_$reflection()]]]);
}

export class InInMaintenanceInfo extends Record {
    constructor(ToolInfoType, Title, Subtitle, CurrentAssignment, Date$) {
        super();
        this.ToolInfoType = ToolInfoType;
        this.Title = Title;
        this.Subtitle = Subtitle;
        this.CurrentAssignment = CurrentAssignment;
        this.Date = Date$;
    }
}

export function InInMaintenanceInfo_$reflection() {
    return record_type("Shared.Dashboard.InInMaintenanceInfo", [], InInMaintenanceInfo, () => [["ToolInfoType", InInMaintenanceInfoType_$reflection()], ["Title", string_type], ["Subtitle", string_type], ["CurrentAssignment", option_type(CurrentAssignment_$reflection())], ["Date", class_type("System.DateTime")]]);
}

export class ReleaseDateInfo extends Record {
    constructor(IsOverdue, ReleaseDate, ReceiverName, ReceiverId, Title, Subtitle, Id) {
        super();
        this.IsOverdue = IsOverdue;
        this.ReleaseDate = ReleaseDate;
        this.ReceiverName = ReceiverName;
        this.ReceiverId = ReceiverId;
        this.Title = Title;
        this.Subtitle = Subtitle;
        this.Id = Id;
    }
}

export function ReleaseDateInfo_$reflection() {
    return record_type("Shared.Dashboard.ReleaseDateInfo", [], ReleaseDateInfo, () => [["IsOverdue", bool_type], ["ReleaseDate", class_type("System.DateTime")], ["ReceiverName", string_type], ["ReceiverId", string_type], ["Title", string_type], ["Subtitle", string_type], ["Id", ElementId_$reflection()]]);
}

export class OpenNotification extends Record {
    constructor(NotificationId, EntityName, EntityPath, Timestamp, Sender, Receiver, Storage, AssignmentType, CanDelete, PausedUntil) {
        super();
        this.NotificationId = NotificationId;
        this.EntityName = EntityName;
        this.EntityPath = EntityPath;
        this.Timestamp = Timestamp;
        this.Sender = Sender;
        this.Receiver = Receiver;
        this.Storage = Storage;
        this.AssignmentType = AssignmentType;
        this.CanDelete = CanDelete;
        this.PausedUntil = PausedUntil;
    }
}

export function OpenNotification_$reflection() {
    return record_type("Shared.Dashboard.OpenNotification", [], OpenNotification, () => [["NotificationId", string_type], ["EntityName", string_type], ["EntityPath", list_type(string_type)], ["Timestamp", class_type("System.DateTime")], ["Sender", string_type], ["Receiver", string_type], ["Storage", string_type], ["AssignmentType", string_type], ["CanDelete", bool_type], ["PausedUntil", option_type(class_type("System.DateTime"))]]);
}

export class UpcomingInspectionInfo extends Record {
    constructor(ToolId, IsOverdue, ToolTitle, ToolSubtitle, CurrentAssignment, TemplateName, Date$) {
        super();
        this.ToolId = ToolId;
        this.IsOverdue = IsOverdue;
        this.ToolTitle = ToolTitle;
        this.ToolSubtitle = ToolSubtitle;
        this.CurrentAssignment = CurrentAssignment;
        this.TemplateName = TemplateName;
        this.Date = Date$;
    }
}

export function UpcomingInspectionInfo_$reflection() {
    return record_type("Shared.Dashboard.UpcomingInspectionInfo", [], UpcomingInspectionInfo, () => [["ToolId", ToolId_$reflection()], ["IsOverdue", bool_type], ["ToolTitle", string_type], ["ToolSubtitle", string_type], ["CurrentAssignment", option_type(CurrentAssignment_$reflection())], ["TemplateName", string_type], ["Date", class_type("System.DateTime")]]);
}

export class InspectionStatusInfo extends Record {
    constructor(InspectedCount, TotalRequiredCount, ExpiredCount, FailedCount, NeverInspectedCount, UpcomingInspections) {
        super();
        this.InspectedCount = (InspectedCount | 0);
        this.TotalRequiredCount = (TotalRequiredCount | 0);
        this.ExpiredCount = (ExpiredCount | 0);
        this.FailedCount = (FailedCount | 0);
        this.NeverInspectedCount = (NeverInspectedCount | 0);
        this.UpcomingInspections = UpcomingInspections;
    }
}

export function InspectionStatusInfo_$reflection() {
    return record_type("Shared.Dashboard.InspectionStatusInfo", [], InspectionStatusInfo, () => [["InspectedCount", int32_type], ["TotalRequiredCount", int32_type], ["ExpiredCount", int32_type], ["FailedCount", int32_type], ["NeverInspectedCount", int32_type], ["UpcomingInspections", list_type(UpcomingInspectionInfo_$reflection())]]);
}

export class DashboardData extends Record {
    constructor(InMaintenanceToolsAndSets, Problems, ReminderDates, ToolReturnDates, ReservationInfos, MinimumQuantityReminder, ReleaseDates, OpenNotifications, InspectionStatus) {
        super();
        this.InMaintenanceToolsAndSets = InMaintenanceToolsAndSets;
        this.Problems = Problems;
        this.ReminderDates = ReminderDates;
        this.ToolReturnDates = ToolReturnDates;
        this.ReservationInfos = ReservationInfos;
        this.MinimumQuantityReminder = MinimumQuantityReminder;
        this.ReleaseDates = ReleaseDates;
        this.OpenNotifications = OpenNotifications;
        this.InspectionStatus = InspectionStatus;
    }
}

export function DashboardData_$reflection() {
    return record_type("Shared.Dashboard.DashboardData", [], DashboardData, () => [["InMaintenanceToolsAndSets", list_type(InInMaintenanceInfo_$reflection())], ["Problems", list_type(ProblemReportInfo_$reflection())], ["ReminderDates", list_type(ReminderDateInfo_$reflection())], ["ToolReturnDates", list_type(ToolReturnDateInfo_$reflection())], ["ReservationInfos", list_type(ReservationDto_$reflection())], ["MinimumQuantityReminder", list_type(MinimumQuantityReminder_$reflection())], ["ReleaseDates", option_type(list_type(ReleaseDateInfo_$reflection()))], ["OpenNotifications", list_type(OpenNotification_$reflection())], ["InspectionStatus", option_type(InspectionStatusInfo_$reflection())]]);
}

